import React from 'react';
import PhoneScreen from './PhoneScreen';

const PhoneShell: React.FC<{ isLoading: boolean; analysisKey: number }> = ({ isLoading, analysisKey }) => {
  return (
    <div className="relative mx-auto w-[85%] max-w-[340px] aspect-[9/18] rounded-[2rem] overflow-hidden shadow-[0_0_25px_rgba(34,255,155,0.15)] border border-[#22ff9b22] bg-[#060c1f]">
      {/* تأثير زجاجي خفيف */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent z-20 pointer-events-none"></div>

      {/* شاشة الهاتف */}
      <div className="absolute inset-0 rounded-[2rem] overflow-hidden">
        <PhoneScreen isLoading={isLoading} analysisKey={analysisKey} />
      </div>
    </div>
  );
};

export default PhoneShell;
